import axios from 'axios';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from '../contexts/TranslationContext';
import { API_BASE_URL, ROUTES } from '../constants';

const ForgotPassword: React.FC = () => {
  const { t } = useTranslation();
  const [email, setEmail] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    try {
      await axios.post(`${API_BASE_URL}/auth/forgot-password`, { email });
      setSubmitted(true);
    } catch {
      setError(t.forgotPassword.genericError);
    }
  };

  return (
    <div className="forgot-password">
      <div className="forgot-password__container">
        <div className="forgot-password__card">
          <h1 className="login__title italic-title">{t.forgotPassword.title}</h1>

          {error && <div className="forgot-password__error">{error}</div>}

          {submitted ? (
            <>
              <div className="forgot-password__success">{t.forgotPassword.successMessage}</div>
              <Link to={ROUTES.LOGIN} className="forgot-password__back-link">
                {t.forgotPassword.backToLogin}
              </Link>
            </>
          ) : (
            <form className="forgot-password__form" onSubmit={handleSubmit}>
              <div className="login__field">
                <label htmlFor="email" className="login__label">{t.forgotPassword.email}</label>
                <input
                  id="email"
                  className="login__input"
                  type="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  required
                />
              </div>
              <button type="submit" className="login__submit button_primary">
                {t.forgotPassword.submit}
              </button>
              <Link to={ROUTES.LOGIN} className="forgot-password__back-link">
                {t.forgotPassword.backToLogin}
              </Link>
            </form>
          )}
        </div>
      </div>
    </div>
  );
};

export default ForgotPassword;
